module.exports = __webpack_public_path__ + "static/img/button_return.d88c2d14.svg";